import { METRIC_TYPE } from '../../Widgets/consts/graphTypes';
import { getWidgetCalculationStrategyFromAccountSettings } from '../../Widgets/utils/calculationStrategy';
import { isMedianMetric } from '../../custom-report.util';
import {
  ISSUE_TYPES_KEY,
  IS_ALL_ISSUE_TYPES_SELECTED_KEY
} from 'modals/EditCustomPmMetricsModal/EditCustomPmMetricsModal.constants';
import { metricNames } from '@linearb/linjs-common';

const metricsNamesOfCustomPmMetrics = [
  metricNames.PM_ISSUE_STATE_TRANSITION,
  metricNames.PM_ISSUE_COUNT
];

export const formatWidgetsToV3Metrics = ({
  widgets = [],
  account,
  report,
  metricsCalculationStrategy,
  isCustomPMMetrics,
  getSettingOrDefinitionValue
}) => {
  if (isCustomPMMetrics) {
    return [];
  }

  const isCustomReport = report?.definition?.is_editable && !isCustomPMMetrics;

  return widgets
    .map(({ metrics, agg, name }) => {
      const aggregation =
        getWidgetCalculationStrategyFromAccountSettings({
          account,
          reportName: report.name,
          widgetName: name,
          reportType: isCustomReport ? METRIC_TYPE.custom : ''
        }) ||
        agg ||
        metricsCalculationStrategy;
      const v3WidgetRequestedMetrics = metrics.map(({ name }) => ({
        name,
        ...(isMedianMetric(name) ? { agg: aggregation } : {})
      }));

      return v3WidgetRequestedMetrics;
    })
    .flat();
};

export const formatWidgetsToCustomMetrics = ({
  widgets,
  isCustomPMMetrics
}) => {
  if (!isCustomPMMetrics) {
    return [];
  }
  // filter out reported metrics
  const filteredWidgets = widgets.filter(({ metrics }) =>
    metricsNamesOfCustomPmMetrics.includes(metrics[0].name)
  );
  return filteredWidgets.map(
    ({ filters, metrics, id, calculation_strategy, ...rest }) => ({
      custom_metric_id: id,
      include_issues: true,
      requested_metrics: metrics.map(({ name }) => name),
      // If all issue types are selected, we want to send an empty array to the backend to improve performance.
      filters: {
        ...filters,
        [ISSUE_TYPES_KEY]: filters[IS_ALL_ISSUE_TYPES_SELECTED_KEY]
          ? []
          : filters[ISSUE_TYPES_KEY]
      },
      calculation_strategy,
      ...rest
    })
  );
};

export const formatWidgetsToReportedMetrics = ({
  widgets,
  isCustomPMMetrics
}) => {
  if (!isCustomPMMetrics) {
    return [];
  }

  // filter out custom PM Metrics
  const filteredWidgets = widgets.filter(
    ({ metrics }) => !metricsNamesOfCustomPmMetrics.includes(metrics[0].name)
  );
  return filteredWidgets.map(
    ({ filters, metrics, id, distinct_count, agg }) => ({
      custom_metric_id: id,
      name: `${id}:${metrics[0].name}`,
      distinct_column: filters?.distinct_count,
      agg: filters?.agg,
      filters: [
        {
          column: 'metric',
          type: 'equals',
          value: metrics[0].name
        }
      ]
    })
  );
};
